__turbopack_context__.v({
  "Switch": "_4FaHwW_Switch",
  "Thumb": "_4FaHwW_Thumb",
  "body": "_4FaHwW_body",
  "center": "_4FaHwW_center",
  "editEmailBtn": "_4FaHwW_editEmailBtn",
  "row": "_4FaHwW_row",
  "separator": "_4FaHwW_separator",
  "switchDesc": "_4FaHwW_switchDesc",
  "switchLabel": "_4FaHwW_switchLabel",
  "switchLabelWrapper": "_4FaHwW_switchLabelWrapper",
});
